/* Traductions injectees par theme.liquid (window.themeStrings), avec repli francais */
var DOMA_S = Object.assign({
  cartEmpty: "Votre panier est vide.",
  continueShopping: "Continuer mes achats",
  added: "Ajouté ✓",
  addToCart: "Ajouter au panier",
  soldOut: "Rupture de stock",
  /* Ajouts : ces libelles etaient codes en dur dans le HTML genere,
     donc jamais traduits sur EN / ES / IT / NL / PT-PT. */
  adding: "Ajout…",
  remove: "Retirer",
  decrease: "Diminuer",
  increase: "Augmenter",
  unavailable: "Indisponible"
}, (typeof window !== "undefined" && window.themeStrings) || {});

/* ============================================================
   domacosy — Interactions du thème (vanilla, sans dépendance)
   ============================================================ */
(function () {
  "use strict";

  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || "fr", {
      style: "currency",
      currency: window.DOMA?.currency || "EUR",
    }).format(cents / 100);

  const qs = (s, el = document) => el.querySelector(s);
  const qsa = (s, el = document) => Array.from(el.querySelectorAll(s));
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  /* ---------- Ouverture / fermeture des panneaux ---------- */
  function openPanel(el) { el && el.classList.add("is-open"); }
  function closePanel(el) { el && el.classList.remove("is-open"); }

  const overlay = qs("[data-cart-overlay]");
  const drawer = qs("[data-cart-drawer]");
  const mobileMenu = qs("[data-mobile-menu]");

  function openCart() { openPanel(overlay); openPanel(drawer); document.body.style.overflow = "hidden"; }
  function closeCart() { closePanel(overlay); closePanel(drawer); document.body.style.overflow = ""; }
  function closeAll() {
    closeCart();
    closePanel(mobileMenu);
    document.body.style.overflow = "";
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-cart-open]")) { e.preventDefault(); openCart(); refreshCart(); }
    if (e.target.closest("[data-cart-close]")) { e.preventDefault(); closeCart(); }
    if (e.target.closest("[data-menu-open]")) { openPanel(mobileMenu); document.body.style.overflow = "hidden"; }
    if (e.target.closest("[data-menu-close]")) { closeAll(); }
    if (e.target === overlay) closeCart();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeAll(); });

  /* ---------- Panier : récupération + rendu ---------- */
  async function getCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  function updateCount(count) {
    qsa("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    const list = qs("[data-cart-items]");
    const foot = qs("[data-cart-foot]");
    if (!list) return;

    if (cart.item_count === 0) {
      list.innerHTML =
        `<div class="cart-empty"><p class="muted">${esc(DOMA_S.cartEmpty)}</p>` +
        `<button class="btn btn--ghost" data-cart-close>${esc(DOMA_S.continueShopping)}</button></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    list.innerHTML = cart.items
      .map(
        (it) => `
      <div class="cart-line" data-line-key="${esc(it.key)}">
        <img class="cart-line__img" src="${it.image ? esc(it.image.replace(/(\.[^.]+)(\?.*)?$/, "_120x120$1$2")) : ""}" alt="" loading="lazy" width="60" height="60">
        <div>
          <div class="cart-line__title">${esc(it.product_title)}</div>
          ${it.variant_title && it.variant_title !== "Default Title" ? `<div class="cart-line__variant">${esc(it.variant_title)}</div>` : ""}
          <div class="qty" data-qty>
            <button type="button" data-qty-down aria-label="${esc(DOMA_S.decrease)}">−</button>
            <input type="text" inputmode="numeric" value="${esc(it.quantity)}" data-qty-input readonly>
            <button type="button" data-qty-up aria-label="${esc(DOMA_S.increase)}">+</button>
          </div>
          <button class="cart-line__remove" data-line-remove>${esc(DOMA_S.remove)}</button>
        </div>
        <div class="price">${money(it.final_line_price)}</div>
      </div>`
      )
      .join("");

    const totalEl = qs("[data-cart-total]");
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  async function refreshCart() {
    try { renderCart(await getCart()); } catch (e) { console.error(e); }
  }

  async function changeLine(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    renderCart(await res.json());
  }

  /* ---------- Délégation : quantité + suppression dans le tiroir ---------- */
  document.addEventListener("click", (e) => {
    const line = e.target.closest("[data-line-key]");
    if (!line) return;
    const key = line.dataset.lineKey;
    const input = qs("[data-qty-input]", line);
    const current = parseInt(input.value, 10) || 1;

    if (e.target.closest("[data-qty-up]")) changeLine(key, current + 1);
    if (e.target.closest("[data-qty-down]")) changeLine(key, Math.max(0, current - 1));
    if (e.target.closest("[data-line-remove]")) changeLine(key, 0);
  });

  /* ---------- Ajout au panier (AJAX) ---------- */
  qsa("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = qs('[type="submit"]', form);
      const label = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = DOMA_S.adding; }
      try {
        const fd = new FormData(form);
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: fd,
        });
        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description || DOMA_S.unavailable);
        }
        await refreshCart();
        openCart();
        if (btn) btn.textContent = DOMA_S.added;
        setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1200);
      } catch (err) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        const note = qs("[data-form-error]", form);
        if (note) note.textContent = err.message;
        else alert(err.message);
      }
    });
  });

  /* ---------- Sélection de variante ----------
     RETIRE. Ce bloc faisait doublon avec le script de sections/main-product.liquid :
     les deux lisaient [data-variants-json] et ecrivaient dans [data-variant-price].
     global.js etant charge en defer, il passait en dernier et ecrasait l'affichage
     (symbole monetaire qui saute, puis "NaN €" apres un renommage de champ).
     Le selecteur de la section est desormais seul : il gere en plus la bascule
     d'image et le grisage des options epuisees, que ce bloc ne faisait pas.
     Ne pas le reintroduire ici. -------------------------------------------- */

  /* ---------- Galerie produit ---------- */
  qsa("[data-gallery]").forEach((g) => {
    const main = qs("[data-gallery-main] img", g);
    qsa("[data-gallery-thumb]", g).forEach((t) => {
      t.addEventListener("click", () => {
        const src = t.dataset.full;
        if (main && src) main.src = src;
        qsa("[data-gallery-thumb]", g).forEach((x) => x.setAttribute("aria-current", "false"));
        t.setAttribute("aria-current", "true");
      });
    });
  });

  /* ---------- Quantité sur la page produit ---------- */
  qsa("[data-qty]:not([data-line-key] [data-qty])").forEach((q) => {
    const input = qs("[data-qty-input]", q);
    if (!input || input.readOnly) return;
    qs("[data-qty-up]", q)?.addEventListener("click", () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
    qs("[data-qty-down]", q)?.addEventListener("click", () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    /* Saisie manuelle : empeche 0, negatif ou texte d'atteindre /cart/add.js */
    input.addEventListener("change", () => { input.value = Math.max(1, parseInt(input.value, 10) || 1); });
  });

  /* ---------- Reveal au scroll ---------- */
  const reveals = qsa("[data-reveal]");
  if (reveals.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); } }),
      { threshold: 0.12 }
    );
    reveals.forEach((r) => io.observe(r));
  } else reveals.forEach((r) => r.classList.add("is-visible"));

  /* ---------- Initialisation ---------- */
  refreshCart();
})();
